const activity = {
  getlist: 'activity/getlist-by-admin',
  add: 'activity/add',
  update: 'activity/update',
  remove: 'activity/remove',
  get: 'activity/get-by-admin',
  getall: 'activity/getall',
  clearcache: 'activity/clear-cache',
}
export default activity
